<template>
  <div>
    <div id="container" style="width:100%"></div>
  </div>
</template>
<script>
import { Chart } from "@antv/g2";
import axios from "axios";
export default {
  data() {
    return {
      data: []
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      this.data = [];
      let url = this.httpsBasic.url + this.httpsBasic.index + "home/index";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          // console.log(res.data.data);
          if (
            res.data.data.model_three != undefined &&
            res.data.data.model_three.one_level_list != ""
          ) {
            res.data.data.model_three.one_level_list.forEach(element => {
              if (
                element.is_on_work == 1 &&
                element.project_name != "百协认证签约"
              ) {
                this.data.push({
                  type: element.type == 1 ? "在职" : "离职",
                  pro: element.project_name,
                  value: element.type == 1 ? element.work : element.leave
                });
              }
            });
            this.createCharts();
            const e = document.createEvent("Event");
            e.initEvent("resize", true, true);
            window.dispatchEvent(e);
          }
        });
    },
    createCharts() {
      const chart = new Chart({
        container: "container",
        autoFit: true,
        height: 240,
        appendPadding: [20, 30, 20, 30]
      });

      chart.data(this.data);
      chart.scale("value", {
        nice: true
      });
      chart.legend({
        position: "top"
      });

      chart
        .interval()
        .position("pro*value")
        .color("type")
        .adjust([
          {
            type: "dodge",
            marginRatio: 0
          }
        ]);
      this.data.forEach(item => {
        // console.log(item.type )
        chart.annotation().text({
          position: [item.pro, item.value],
          content: item.value,
          style: {
            textAlign: "center"
          },
          offsetY: -10,
          offsetX: item.type == "在职" ? -20 : 20
        });
      });

      chart.render();
    }
  }
};
</script>
